import React from 'react';
import {BaseModal} from '../../comun/Index';
import { TextField, FormGroup, FormControlLabel, Checkbox } from '@mui/material';

class Nueva extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      nombre:"",
      mesa:false
    }
  }

  render(){
    const {nombre, mesa} = this.state;
    return(
      <BaseModal
        titulo="Nueva área"
        loading={false}
        botonera={[
          {titulo:"Salir", backgroundColor:'#FF2C00', onClick: () => this.props.salir()},
          {titulo:"Guardar", backgroundColor:'#00B845', onClick: () => this.props.guardar(this.state)}
        ]}
      >
        <div className="Seccion" style={{width:'90%'}}>
          <TextField
            size="small"
            style={{flex:4,textAlign:'center',minWidth:0,margin:'5px 1px'}}
            inputProps={{style:{textAlign:'center'}}}
            label="Nombre del área"
            value={nombre}
            onChange={(e) => this.setState({nombre:e.target.value})}
            variant="outlined"
          />
          <FormGroup
            style={{flex:1, textAlign:'center', alignItems:'center', justifyContent:'center', display:'flex', overflow:'hidden'}}
            checked={mesa}
            onChange={(e) => this.setState({mesa:e.target.checked})}
          >
            <FormControlLabel control={<Checkbox />} label="Mesa de entrada" />
          </FormGroup>
        </div>
      </BaseModal>
    );
  }
}

export default Nueva;
